import { render } from "./Failed.vue?vue&type=template&id=112f99ae"
import script from "./Failed.vue?vue&type=script&lang=js"
export * from "./Failed.vue?vue&type=script&lang=js"

import exportComponent from "E:\\cymcorp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__